import axios, { AxiosError } from 'axios';

export class ApiErrorCodes {
  public static readonly UNAUTHORIZED = 401;
  public static readonly TOO_MANY_REQUESTS = 429;
  public static readonly INTERNAL_SERVER_ERROR = 500;
  public static readonly SERVICE_UNAVAILABLE = 503;
  public static readonly NOT_FOUND = 404;
  public static readonly BAD_REQUEST = 400;
}

export class ApiError<T> {
  readonly responseErrorCode?: number;
  payload?: T;

  constructor(payload?: T, responseErrorCode?: number) {
    this.payload = payload;
    this.responseErrorCode = responseErrorCode;
  }
}

export const parseApiResponseError = <T>(error: unknown): ApiError<T> => {
  if (!axios.isAxiosError(error)) {
    return new ApiError();
  }

  const axiosError = error as AxiosError<T>;
  const data = axiosError?.response?.data;

  return new ApiError<T>(data, axiosError.response?.status);
};
